import { Outlet, useLocation, useOutletContext } from 'react-router'

import { useEspacio } from '../api/consultas'
import type { Contexto } from '../paginas/Modulo'
import { correoDeContacto, ErrorDePantalla } from './ErrorDePantalla'
import { Aviso } from './ui'

/**
 * Lo que envuelve cada pantalla dentro del marco (una ruta sin dirección propia, entre
 * `Marco` y las pantallas; App.tsx): la banda de la cuenta suspendida, arriba, y la barrera
 * que evita que un fallo al pintar deje el panel en blanco. Pasa el contexto del marco tal
 * cual: las pantallas lo siguen leyendo con `useOutletContext`.
 */
export const Pantalla = () => {
  const contexto = useOutletContext<Contexto>()
  const { pathname } = useLocation()
  return (
    <>
      <BandaDeCuentaSuspendida espacio={contexto.espacio} />
      <ErrorDePantalla clave={pathname}>
        <Outlet context={contexto} />
      </ErrorDePantalla>
    </>
  )
}

/**
 * Una cuenta suspendida lo dice arriba de cada pantalla, con lo que significa y a quién
 * escribir, en vez de enterarse al final del asistente de alta. El estado lo lee cualquiera
 * de la cuenta (§5); qué se puede hacer lo sigue decidiendo el núcleo en cada llamada.
 */
export const BandaDeCuentaSuspendida = ({ espacio }: { espacio: number }) => {
  const { data } = useEspacio(espacio)
  if (data?.estado !== 'suspendido') return null
  return (
    <div className="mb-6">
      <Aviso tono="error">
        <strong className="font-semibold">Esta cuenta está suspendida.</strong> Mientras lo esté, tus webs no se ven en internet, no reciben mensajes ni pedidos y no se pueden crear webs nuevas. Lo que
        tienes guardado sigue aquí. Para reactivarla, escríbenos a{' '}
        <a className="font-medium text-violeta underline underline-offset-2" href={`mailto:${correoDeContacto()}?subject=${encodeURIComponent(`Cuenta suspendida: ${data.nombre}`)}`}>
          {correoDeContacto()}
        </a>
        .
      </Aviso>
    </div>
  )
}
